window.addEventListener('load', () => {
    const header = document.querySelector<HTMLElement>('.header-component');
    const menu = header?.querySelector('.header-inner ul.menu');
    const parents = menu?.querySelectorAll<HTMLElement>(':scope > li.menu-item-has-children');

    if (!header || !menu || !parents) return;

    parents.forEach(parent => {
        const link = parent.querySelector<HTMLElement>(':scope > a');
        const submenu = parent.querySelector<HTMLElement>(':scope > .sub-menu-wrapper');

        if (!link || !submenu) return;

        link.addEventListener('click', () => {
            const isOpen = parent.classList.contains('open');

            parents.forEach(p => {
                if (p === parent) return;
                p.classList.remove('open');
                const sm = p.querySelector<HTMLElement>(':scope > ul.sub-menu');
                if (sm) sm.style.maxHeight = '0px';
            });

            if (!isOpen) {
                parent.classList.add('open');
                submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            } else {
                parent.classList.remove('open');
                submenu.style.maxHeight = '0px';
            }
        });
    });

    // if clicking outside menu, close all menu's
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (!menu.contains(target)) {
            parents.forEach(parent => {
                parent.classList.remove('open');
                const sm = parent.querySelector<HTMLElement>(':scope > ul.sub-menu');
                if (sm) sm.style.maxHeight = '0px';
            });
        }
    });
});